export default __webpack_public_path__ + "2ce5d8be3b3a819cfc7cb6dd713241b2.svg";